"use client";

import { onDeepLink } from "@v1/native";
import { useRouter } from "next/navigation";
import { useEffect } from "react";

/**
 * Routes universal-link opens (hausverwalter.ai, portalzugang.de and their
 * customer subdomains) into the in-app router as a path. Inert on web.
 */
export function NativeDeepLinkProvider(): null {
  const router = useRouter();

  useEffect(() => {
    let active = true;
    let cleanup: () => void = () => {};

    void onDeepLink((url) => {
      const path = toInternalPath(url);
      if (path) router.push(path);
    }).then((unsubscribe) => {
      if (active) cleanup = unsubscribe;
      else unsubscribe();
    });

    return () => {
      active = false;
      cleanup();
    };
  }, [router]);

  return null;
}

/** Extract the in-app path (pathname + search + hash) from a deep-link URL. */
function toInternalPath(rawUrl: string): string | null {
  try {
    const url = new URL(rawUrl);
    const path = `${url.pathname}${url.search}${url.hash}`;
    // Reject protocol-relative ("//host") paths — router.push would go off-origin.
    if (!path.startsWith("/") || path.startsWith("//")) return null;
    return path;
  } catch {
    return null;
  }
}
